import * as Rx from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { ApiService } from 'v2/services/api';

export type requestAnticipation = {
  amount_requested: number;
  total_invoices: number;
};

export class Anticipation {
  private loading$ = new Rx.BehaviorSubject<boolean>(true);
  private currentBalance$ = new Rx.BehaviorSubject<number>(null);
  private totalInvoices$ = new Rx.BehaviorSubject<number>(null);
  private totalFee$ = new Rx.BehaviorSubject<number>(null);

  constructor(private apiService: ApiService) {}

  public getCurrentBalance = (): Rx.Observable<number> => this.currentBalance$;
  public getTotalInvoices = (): Rx.Observable<number> => this.totalInvoices$;
  public getTotalFee = (): Rx.Observable<number> => this.totalFee$;

  public setCurrentBalance = (value: number) => this.currentBalance$.next(value);
  public setTotalInvoices = (value: number) => this.totalInvoices$.next(value);
  public setTotalFee = (value: number) => this.totalFee$.next(value);

  public isLoading = () => this.loading$;

  public getAvailable = () => this.apiService.get('financial-statement/balance/available-to-anticipate');
  public getAvailableByValue = (requestedValue: number) => {
    return this.apiService.get(`financial-statement/balance/available-to-anticipate?requested_value=${requestedValue}`);
  };

  public getSuggestionAnticipation = () => this.apiService.get('anticipation/suggestion');

  public requestAnticipation(dataRequest: requestAnticipation) {
    return this.apiService.post('anticipation/anticipate_value', dataRequest).pipe(tap((response) => response));
  }

  public loadData() {
    this.loading$.next(true);

    return this.getAvailable().pipe(
      finalize(() => this.loading$.next(false)),
      tap((response) => {
        this.setCurrentBalance(response.data.total);
        this.setTotalInvoices(response.data.invoices);
        this.setTotalFee(response.data.total_fee);
      })
    );
  }
}

export const anticipationService = new Anticipation(apiService);
